//frontend/src/components/route/ProtectedAdminRoute.js
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import Loader from '../layouts/Loader';

export default function ProtectedAdminRoute({ children }) {
    const { isAuthenticated, loading, admin } = useSelector(state => state.adminState);

    // Show loader while checking authentication
    if (loading) {
        return <Loader/>;
    }

    // If not authenticated, redirect to login
    if (!isAuthenticated) {
        return <Navigate to="/admin/login" />;
    }

    // Check if admin object exists and has necessary properties
    if (!admin) {
        return <Navigate to="/admin/login" />;
    }

    // If authenticated and admin exists, render children
    return children;
}
